/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Billing_Plan_HintInputs */

const cs_billing_plan_hint = /** @type {(inputs: Billing_Plan_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tarify kanceláře ${i?.name}. Kredity v tarifu dobíjejí firemní peněženku každý cyklus; těžké AI jde přes přečerpání kreditů.`)
};

const en_billing_plan_hint = /** @type {(inputs: Billing_Plan_HintInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Office tariffs for ${i?.name}. Credits in the plan top up the org wallet each period; heavy AI still uses credit overage.`)
};

/**
* | output |
* | --- |
* | "Office tariffs for {name}. Credits in the plan top up the org wallet each period; heavy AI still uses credit overage." |
*
* @param {Billing_Plan_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_hint = /** @type {((inputs: Billing_Plan_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_hint(inputs)
	return cs_billing_plan_hint(inputs)
});